import React, { useState } from "react";
// import invoice from "../Assets/invoice.png";
import { useNavigate } from "react-router";
import WarrCard from "../warrCard/warrCard";
import {
  ax_warranty_getInvoiceFile,
  ax_warranty_updateWarranty,
} from "../api/warranty";
import toast from "react-hot-toast";
import { ArrRefresh2O } from "lovedicons/dist/arrO";
import Modal from "../component/Modal";

const InputField = ({ label, value, readOnly = true }) => (
  <div className="flex-grow border-gray border-2 p-2 rounded-lg">
    <label className="block text-gray-500 text-sm">{label}</label>
    <input
      type="text"
      value={value}
      className="w-full outline-none border-gray-300 "
      readOnly={readOnly}
    />
  </div>
);

const TwoColumnRow = ({ fields }) => (
  <div className="flex flex-row w-full gap-3">
    {fields.map((field, index) => (
      <InputField key={index} {...field} />
    ))}
  </div>
);

const ThreeColumnRow = ({ fields }) => (
  <div className="flex flex-row w-full gap-3">
    {fields.map((field, index) => (
      <InputField key={index} {...field} />
    ))}
  </div>
);

const WarrantyRequest = ({ selectedWarranty, createdFromBrand }) => {
  const navigate = useNavigate();
  const [showInvoice, setShowInvoice] = useState(false);

  const [invoiceFile, setInvoiceFile] = useState(null);

  const [isLoading, setIsLoading] = useState(false);
  const [clickedBtn, setClickedBtn] = useState("");

  const handleViewInvoice = async () => {
    try {
      const axGetInvoiceFile = await ax_warranty_getInvoiceFile(
        selectedWarranty?._id
      );

      if (axGetInvoiceFile.data) {
        if (axGetInvoiceFile.data.frameNo === selectedWarranty?.frameNo) {
          console.log("axGe - ", axGetInvoiceFile);
          setInvoiceFile(axGetInvoiceFile.data.invoiceFile);
          setShowInvoice(true);
        } else {
          toast.error("Invoice file not found!");
        }
      }
    } catch (error) {
      console.error("Error fetching invoice file:", error);
      toast.error("Failed to fetch the invoice file!");
    }
  };
  const handleCloseInvoice = () => setShowInvoice(false);
  // function handleBase64File(base64String) {
  //   if (!base64String.includes(",")) {
  //     console.error("Invalid Base64 format");
  //     return null;
  //   }

  //   const [prefix, base64Data] = base64String.split(",");
  //   const mimeTypeMatch = prefix.match(/:(.*?);/);

  //   if (!mimeTypeMatch) {
  //     console.error("MIME type not found");
  //     return null;
  //   }

  //   const mimeType = mimeTypeMatch[1]; // Extract MIME type
  //   const byteCharacters = atob(base64Data);
  //   const byteNumbers = new Array(byteCharacters.length);

  //   for (let i = 0; i < byteCharacters.length; i++) {
  //     byteNumbers[i] = byteCharacters.charCodeAt(i);
  //   }

  //   const byteArray = new Uint8Array(byteNumbers);
  //   const blob = new Blob([byteArray], { type: mimeType });
  //   const blobUrl = URL.createObjectURL(blob);

  //   return { mimeType, blobUrl };
  // }

  const onApproveRejectClick = async (
    _id,
    approvalStatus,
    selectedWarranty
  ) => {
    if (!selectedWarranty) return;

    const { frameNo, wowNo, email, name } = selectedWarranty;

    const payload = {
      warrStatus: approvalStatus === "Approve" ? "Approved" : "Rejected",
      frameNo,
      wowNo,
      email,
      name,
      createdFromBrand,
    };

    try {
      setIsLoading(true);
      setClickedBtn(approvalStatus);
      const res = await ax_warranty_updateWarranty(_id, payload);

      console.log("res -", JSON.stringify(res));
      console.log("payload -", JSON.stringify(payload));

      if (res?.data) {
        setIsLoading(true);
        setClickedBtn(approvalStatus);
        navigate("/");
        toast.success(res?.description);
      }
    } catch (error) {
      console.error("Error updating warranty:", error);
      setIsLoading(true);
      setClickedBtn(approvalStatus);
    }
  };

  // console.log("selectedWarranty", selectedWarranty);
  // console.log("createdFromBrand", createdFromBrand);

  return (
    <main className="ml-4 p-6 w-full flex bg-white rounded-lg">
      <main className="w-full">
        <header className="flex justify-between items-center mb-6">
          <div className="flex flex-row gap-6 items-center">
            <div
              onClick={() => {
                navigate(-1);
              }}
            >
              <svg
                className="cursor-pointer"
                width="7"
                height="17"
                viewBox="0 0 7 17"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M5.875 1.25C-0.625 8.75 -0.625 8.75 5.875 15.75"
                  stroke="black"
                  strokeOpacity="0.5"
                />
              </svg>
            </div>
            <h1 className="text-2xl font-semibold">Warranty Card Request</h1>
          </div>
          <div className="space-x-2">
            <button
              className="px-4 py-2 bg-green-300 text-black rounded-md hover:bg-green-400 font-semibold"
              onClick={() =>
                onApproveRejectClick(
                  selectedWarranty?._id,
                  "Approve",
                  selectedWarranty
                )
              }
            >
              {isLoading && clickedBtn === "Approve" ? (
                <div className="w-full">
                  <ArrRefresh2O className="w-5 h-5 animate-spin" />
                </div>
              ) : (
                "Approve"
              )}
            </button>
            <button
              className="px-4 py-2 bg-red-300 text-gray-800 rounded-md hover:bg-red-400 font-semibold"
              onClick={() =>
                onApproveRejectClick(
                  selectedWarranty?._id,
                  "Reject",
                  selectedWarranty
                )
              }
            >
              {isLoading && clickedBtn === "Reject" ? (
                <div className="w-full">
                  <ArrRefresh2O className="w-5 h-5 animate-spin" />
                </div>
              ) : (
                "Reject"
              )}
            </button>
          </div>
        </header>

        <main className="flex flex-row gap-6">
          <section className="bg-white p-6 rounded-lg shadow-md w-full">
            <form className="flex flex-col gap-4">
              <InputField label="Name" value={selectedWarranty?.name} />
              <TwoColumnRow
                fields={[
                  { label: "Email", value: selectedWarranty?.email },
                  { label: "Phone", value: selectedWarranty?.phone },
                ]}
              />
              <TwoColumnRow
                fields={[
                  { label: "Use Case", value: selectedWarranty?.useCase },
                  { label: "Age Group", value: selectedWarranty?.ageGroup },
                ]}
              />
              <TwoColumnRow
                fields={[
                  { label: "Wow No", value: selectedWarranty?.wowNo },
                  { label: "Frame Number", value: selectedWarranty?.frameNo },
                ]}
              />
              <ThreeColumnRow
                fields={[
                  { label: "Pin Code", value: selectedWarranty?.pincode },
                  { label: "State", value: selectedWarranty?.state },
                  { label: "City", value: selectedWarranty?.city },
                ]}
              />
              <ThreeColumnRow
                fields={[
                  {
                    label: "Brand",
                    value: selectedWarranty?.brand,
                  },
                  {
                    label: "Source of Purchase",
                    value: selectedWarranty?.sourceOfPurchase,
                  },
                  {
                    label: "Purchase Date",
                    value:
                      selectedWarranty?.purchaseDate &&
                      !isNaN(new Date(selectedWarranty.purchaseDate))
                        ? new Date(selectedWarranty.purchaseDate)
                            .toISOString()
                            .split("T")[0]
                        : "",
                  },
                ]}
              />
            </form>

            <div className="mt-3 flex justify-end">
              <button
                onClick={handleViewInvoice}
                className="bg-gray-800 text-white px-6 py-2 rounded-lg hover:bg-gray-700"
              >
                View Invoice
              </button>
            </div>

            <Modal isOpen={showInvoice} onClose={handleCloseInvoice}>
              <div className="p-3 h-full flex flex-col items-center justify-center overflow-scroll">
                {invoiceFile ? (
                  invoiceFile.endsWith(".pdf") ? (
                    <iframe
                      src={invoiceFile}
                      className="w-full h-full border"
                      title="Invoice PDF"
                    />
                  ) : (
                    <img
                      src={invoiceFile}
                      alt="Invoice File"
                      className="max-w-full max-h-full object-scale-down"
                    />
                  )
                ) : (
                  <p>No invoice available</p>
                )}
              </div>
            </Modal>
          </section>
          <WarrCard
            selectedWarranty={selectedWarranty}
            createdFromBrand={createdFromBrand}
          />
        </main>
      </main>
    </main>
  );
};

export default WarrantyRequest;

// _id
// 67814e59ce93485d058ac8da
// name
// "pravin "
// email
// "pravin@gmail.com"
// phone
// "9876543210"
// wowNo
// "9876543212345678"
// frameNo
// "98765432"
// pincode
// "654321"
// state
// "kbxkuy"
// city
// "ugk"
// sourceOfPurchase
// "Retail"
// purchaseDate
// 2025-01-01T00:00:00.000+00:00
// brand
// "BSA"
// dealerName
// "hbjh"
// useCase
// "Commercial"
// ageGroup
// "18 - 35"
// invoiceFile
// "C:\fakepath\BSA_Logo.png"

// issues
// Array (empty)

// images
// Array (empty)
// createdFromBrand
// "trackaAndTrail"

// import React, { useState } from "react";
// import invoice from "../Assets/invoice.png";
// // import React from "react";

// const WarrantyRequest = ({ selectedWarranty }) => {
//   const [showInvoice, setShowInvoice] = useState(false);

//   const handleViewInvoice = () => {
//     setShowInvoice(true);
//   };

//   const handleCloseInvoice = () => {
//     setShowInvoice(false);
//   };

//   return (
//     <main className="ml-4 p-6 w-full bg-white rounded-lg">
//       <header className="flex justify-between items-center mb-6">
//         <div className="flex flex-row gap-6 items-center">
//           <svg
//             className="cursor-pointer"
//             width="7"
//             height="17"
//             viewBox="0 0 7 17"
//             fill="none"
//             xmlns="http://www.w3.org/2000/svg"
//           >
//             <path
//               d="M5.875 1.25C-0.625 8.75 -0.625 8.75 5.875 15.75"
//               stroke="black"
//               stroke-opacity="0.5"
//             />
//           </svg>
//           <h1 className="text-2xl font-semibold">Warranty Card Request</h1>
//         </div>
//         <div className="space-x-2">
//           <button className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700">
//             Approve
//           </button>
//           <button className="px-4 py-2 bg-gray-300 text-gray-800 rounded-md hover:bg-gray-400">
//             Reject
//           </button>
//         </div>
//       </header>

//       <main className="flex flex-row gap-6 w-2/4">
//         {/* Left Section */}

//         <section className="bg-white p-6 rounded-lg shadow-md w-full">
//           <form className="flex flex-col gap-4">
//             <div className="border-gray border-2 w-full px-2 rounded-lg">
//               <label className="block text-gray-500 text-sm">Name</label>
//               <input
//                 type="text"
//                 value="pravin"
//                 className="w-full outline-none rounded-md shadow-sm"
//                 readOnly
//               />
//             </div>

//             <div className="flex flex-row w-full gap-6">
//               <div className="flex-grow border-gray border-2 px-2 rounded-lg">
//                 <label className="block text-gray-500 text-sm">Email</label>
//                 <input
//                   type="email"
//                   value="@gmail.com"
//                   className="w-full outline-none border-gray-300 rounded-md shadow-sm"
//                   readOnly
//                 />
//               </div>

//               <div className="flex-grow border-gray border-2 px-2 rounded-lg">
//                 <label className="block text-gray-500 text-sm">Phone</label>
//                 <input
//                   type="text"
//                   value="+91 9876543212"
//                   className="w-full outline-none border-gray-300 rounded-md shadow-sm"
//                   readOnly
//                 />
//               </div>
//             </div>

//             <div className="flex flex-row w-full gap-6">
//               <div className="flex-grow border-gray border-2 px-2 rounded-lg">
//                 <label className="block text-gray-500 text-sm">Use Case</label>
//                 <input
//                   type="text"
//                   value="Fitness"
//                   className="w-full outline-none border-gray-300 rounded-md shadow-sm"
//                   readOnly
//                 />
//               </div>
//               <div className="flex-grow border-gray border-2 px-2 rounded-lg">
//                 <label className="block text-gray-500 text-sm">Age Group</label>
//                 <input
//                   type="text"
//                   value="18 - 35"
//                   className="w-full outline-none border-gray-300 rounded-md shadow-sm"
//                   readOnly
//                 />
//               </div>
//             </div>

//             <div className="flex flex-row w-full gap-6">
//               <div className="flex-grow border-gray border-2 px-2 rounded-lg">
//                 <label className="block text-gray-500 text-sm">Tax S.No</label>
//                 <input
//                   type="text"
//                   value="5679-0987-4567-4309"
//                   className="w-full outline-none border-gray-300 rounded-md shadow-sm"
//                   readOnly
//                 />
//               </div>
//               <div className="flex-grow border-gray border-2 px-2 rounded-lg">
//                 <label className="block text-gray-500 text-sm">
//                   Frame Number
//                 </label>
//                 <input
//                   type="text"
//                   value="756-85-212"
//                   className="w-full outline-none border-gray-300 rounded-md shadow-sm"
//                   readOnly
//                 />
//               </div>
//             </div>

//             <div className="flex flex-row w-full gap-6">
//               <div className="flex-grow border-gray border-2 px-2 rounded-lg">
//                 <label className="block text-gray-500 text-sm">Pin Code</label>
//                 <input
//                   type="text"
//                   value="600045"
//                   className="w-full outline-none border-gray-300 rounded-md shadow-sm"
//                   readOnly
//                 />
//               </div>
//               <div className="flex-grow border-gray border-2 px-2 rounded-lg">
//                 <label className="block text-gray-500 text-sm">State</label>
//                 <input
//                   type="text"
//                   value="Tamil Nadu"
//                   className="w-full outline-none border-gray-300 rounded-md shadow-sm"
//                   readOnly
//                 />
//               </div>
//               <div className="flex-grow border-gray border-2 px-2 rounded-lg">
//                 <label className="block text-gray-500 text-sm">City</label>
//                 <input
//                   type="text"
//                   value="Chennai"
//                   className="w-full outline-none border-gray-300 rounded-md shadow-sm"
//                   readOnly
//                 />
//               </div>
//             </div>

//             <div className="flex flex-row w-full gap-6">
//               <div className="flex-grow border-gray border-2 px-2 rounded-lg">
//                 <label className="block text-gray-500 text-sm">Brand</label>
//                 <input
//                   type="text"
//                   value="BSA"
//                   className="w-full outline-none border-gray-300 rounded-md shadow-sm"
//                   readOnly
//                 />
//               </div>
//               <div className="flex-grow border-gray border-2 px-2 rounded-lg">
//                 <label className="block text-gray-500 text-sm">
//                   Source of Purchase
//                 </label>
//                 <input
//                   type="text"
//                   value="Track & Trail Website"
//                   className="w-full outline-none border-gray-300 rounded-md shadow-sm"
//                   readOnly
//                 />
//               </div>
//               <div className=" flex-grow border-gray border-2 px-2 md:col-span-2 rounded-lg">
//                 <label className="block text-gray-500 text-sm">
//                   Purchase Date
//                 </label>
//                 <input
//                   type="text"
//                   value="12-12-2022"
//                   className="w-full outline-none border-gray-300 rounded-md shadow-sm"
//                   readOnly
//                 />
//               </div>
//             </div>
//           </form>

//           {/* View Invoice Button */}
//           <div className="flex bg-gray-300 rounded-lg p-6 py-24 mt-5 justify-center items-center">
//             <button
//               onClick={handleViewInvoice}
//               className="bg-gray-800 text-white px-6 py-2 rounded-lg hover:bg-gray-700"
//             >
//               View Invoice
//             </button>
//           </div>
//           {/* Invoice Modal */}
//           {showInvoice && (
//             <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center">
//               <div className="bg-white rounded-lg shadow-lg w-3/4 p-6 relative h-3/4">
//                 <button
//                   onClick={handleCloseInvoice}
//                   className="absolute top-2 right-2 text-black p-2 rounded-full "
//                 >
//                   X
//                 </button>
//                 {/* Invoice Content */}
//                 <img
//                   src={invoice}
//                   alt=""
//                   className="w-full h-full object-cover mx-auto"
//                 />
//               </div>
//             </div>
//           )}
//         </section>

//         {/* Right Section */}
//       </main>
//     </main>
//   );
// };

// export default WarrantyRequest;
